import React from 'react';
import { Dropdown, Nav } from 'react-bootstrap';

export const HelpSection: React.FC = () => {
  return (
    <Dropdown align="end">
      <Dropdown.Toggle
        as={Nav.Link}
        style={{ display: 'flex', alignItems: 'center', gap: 6 }}
      >
        <span style={{ display: 'inline-block', verticalAlign: 'middle' }}>
          Help
        </span>
      </Dropdown.Toggle>
      <Dropdown.Menu style={{ zIndex: '1030', border: '1px solid #000' }}>
        <Dropdown.Item
          as="a"
          href="https://iweof.sharepoint.com/:u:/r/teams/o365g_unitoperationsreporting_itnl012/SitePages/Home.aspx?csf=1&web=1&e=k0MMuy"
          target="_blank"
          rel="noopener noreferrer"
        >
          Documentation
        </Dropdown.Item>
        <Dropdown.Item
          as="a"
          href="https://iweof.sharepoint.com/:u:/r/teams/o365g_unitoperationsreporting_itnl012/SitePages/Get-support-or-raise-an-incident.aspx?csf=1&web=1&e=ffWplY"
          target="_blank"
          rel="noopener noreferrer"
        >
          Raise Incident
        </Dropdown.Item>
        <Dropdown.Item
          as="a"
          href="https://isubscribe.ikea.net/channels/36002"
          target="_blank"
          rel="noopener noreferrer"
        >
          iSubscribe
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
};
